import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AddressRoutingModule } from './address-routing.module';
import { AddressComponent } from './address.component';
import { FormsModule } from '@angular/forms';
import { AddressListComponent } from './address-list/address-list.component';
import { AddressEditComponent } from './address-edit/address-edit.component';
import { AddressDetailsComponent } from './address-details/address-details.component';
import { AddressCreateComponent } from './address-create/address-create.component';
import { AddressDetailsViewComponent } from './address-details-view/address-details-view.component';
import { AddressFormComponent } from './address-form/address-form.component';
import { AddressViewComponent } from './address-view/address-view.component';
import { MyCustomMaterialModule } from 'san-common';

@NgModule({
  declarations: [
    AddressComponent,
  AddressListComponent,
  AddressEditComponent,
  AddressDetailsComponent,
  AddressEditComponent,
  AddressCreateComponent,
  AddressDetailsViewComponent,
  AddressFormComponent,
  AddressViewComponent
  ],
  imports: [
    CommonModule,
    AddressRoutingModule,
    FormsModule,
    MyCustomMaterialModule
  ],
  exports: [
    AddressComponent,
  AddressListComponent,
  AddressEditComponent,
  AddressDetailsComponent,
  AddressEditComponent,
  AddressCreateComponent,
  AddressDetailsViewComponent,
  AddressFormComponent,
  AddressViewComponent
  ]
})
export class AddressModule { }
